import React from 'react';
import I18nTabs from '../../../../common/components/I18nTabs';

const Description = (props) => {
  
  const {
    i18n_description,
    i18n_title
  } = props.data;

  const { onChange } = props;

  const i18nArr = [
    { name: 'i18n_title', value: i18n_title, desc: 'Title' },
    { name: 'i18n_description', value: i18n_description, desc: 'Description' }
  ];

  return (
      <I18nTabs
        data={i18nArr}
        onChange={onChange}/>
  );
};

export default Description;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Panes/Description.js